import { Skeleton, Td, Tr, SkeletonProps } from "@chakra-ui/react"
import { useMemo } from "react"

interface TableSkeletonProps extends SkeletonProps {
    rowsCount?: number, rowHeight?: any, colSpan?: number
}

export const TableSkeleton = ({ rowsCount = 10, colSpan = 1, isLoaded = false, children, rowHeight, height = '20px', ...rest }: TableSkeletonProps) => {
    const rowsArray = useMemo(() => Array.from(Array(rowsCount).keys()), [rowsCount])

    return isLoaded ? children : (rowsArray.map((id) => (<Tr key={id} height={rowHeight}><Td colSpan={colSpan}><Skeleton {...rest} height={height} /></Td></Tr>)))
}